<template>
  <div>
  <el-container>

      <el-container>
        <el-aside width="200px">
          <div class="main-nav">
            <img class="dashboard-logo" src="../../assets/logo.png">
            <ul>
              <li v-if="isSuperAdmin"><router-link to="/admin-panel/"><i class="fas fa-users"></i>Users</router-link> </li>
              <li><router-link to="/admin-panel/voting"><i class="fas fa-check-circle"></i>Voting</router-link> </li>
              <li v-if="isSuperAdmin"><router-link to="/admin-panel/sponsors"><i class="fas fa-star"></i>Sponsors</router-link></li>
              <li v-if="isSuperAdmin"><router-link to="/admin-panel/content"><i class="fas fa-book"></i>Content</router-link></li>
              <li v-if="isSuperAdmin"><router-link to="/admin-panel/programs"><i class="fas fa-book"></i>Programs</router-link></li>
              <li v-if="isSuperAdmin"><router-link to="/admin-panel/equipment"><i class="fas fa-book"></i>Equipment</router-link></li>
            </ul>
          </div>
        </el-aside>
        <el-main>
          <div class="admin-wrapper">
            <router-view></router-view>
          </div>
        </el-main>

      </el-container>
    </el-container>
  </div>
</template>

<script>


export default {
  name: 'dashboard',
  data () {
    return {
      msg: 'This is the forgot',
      isSuperAdmin: false,
    }
  },
  mounted () {
    var user = Parse.User.current();
    if(!user){
      this.$router.push('/login?destination=/admin-panel');
    }else{
      if(!user.get('isAdmin')){
        this.$router.push('/login?destination=/dashboard');
      }
      this.isSuperAdmin = user.get('isSuperAdmin');
    }
  }
}
</script>

<style>
.admin-title {
  font-family: prohibition;
  font-size: 20px;
  color: #999;
  text-align: left;
}
.admin-container{
  background-color: #FFF;
  width: 100%;
  display: inline-block;
  margin-bottom: 30px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  padding: 20px;
}
.main-nav {
  background-color: #002146;
  width: 200px;
  height: 100%;
  position: fixed;
  border-top: 5px solid #D70073;
  left: 0;
}
.admin-wrapper {
  padding: 30px 70px 20px 30px;

  margin: 0 auto;
}
.adds-container h4 {
  color: #666;
  margin: 0 auto 10px;
}
.el-main {
  padding: 0;
  background-color: #EEEEEE;
}
.el-header {
  background-color: #FFF;
  z-index: 100;
  position: relative;
}
.dashboard-logo{
  width: 100px;
  margin: 10px auto;
}
.main-nav ul {
  list-style: none;
  padding-left: 20px;
}
.main-nav ul li{
  text-align: left;
  color: #9BA1AC;
  line-height: 36px;
  font-weight: normal;
  font-size: 12px;
}
.main-nav ul li a {
  color: #9BA1AC;
  text-decoration: none;
}
.main-nav ul li i {
  margin-right: 10px;
}

.sponsor-title {
  /* font-family: "prohibition";
  color: #666;
  font-size: 18px;
  text-align: left;
  line-height: 60px;
  float: left; */
}
.sponsor-image {
  float: left;
  width: 150px;
  margin-top: 10px;
}
.day-section{
  font-family: "prohibition";
  color: #666;
  width: 30%;
  float: right;
  margin: 0;
}
.day-section h4 {
  margin: 5px 0 0;
  text-align: right;

}
.day-section h5{
  font-family: "prohibition";
  color: #666;
  text-align: right;
  margin: 0;
  font-size: 25px;
  color: #D70073;
}
.add-box {
  margin-bottom: 20px;
}
.add-box img {
  width: 100%;
}
.el-row {
  margin-bottom: 30px!important;
}
</style>
